import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { apiSymbolToSymbol, IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const loadAccountSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetPayload(MarkoutAction.loadAccountSymbols.started),
    switchMap((params) => {
      const request$ = (params.reportId !== undefined && params.jobId !== undefined)
        ? moApi.getReportAccountSymbols(params.reportId, params.jobId, params.serverId, params.accountId)
        : moApi.getDashboardAccountSymbols(params.serverId, params.accountId);

      return request$.pipe(
        mergeMap((response) => [
          MarkoutAction.loadAccountSymbols.done({
            params,
            result: response.data.map((symbol) => apiSymbolToSymbol(symbol, params.serverId, params.accountId)),
          }),
        ]),
        catchApiError((error) => [
          MarkoutAction.loadAccountSymbols.failed({ params, error }),
        ]),
      );
    }),
  );
